export const formatHumansBs = (monto) => {
  return new Intl.NumberFormat("es-BO", {
    style: "currency",
    currency: "BOB",
  }).format(monto);
};

export const formatHumansDate = ( fecha ) => {
  // console.log(fecha)
  const fechaISO = new Date(`${fecha}T00:00:00`);
  return new Intl.DateTimeFormat('es-ES', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format( fechaISO );

}